var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.602,
    height: 19.602,
    viewBox: "0 0 19.602 19.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#316391;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5.168a.574.574,0,0,0-.812,0L12.26,4.594H2.224A1.725,1.725,0,0,0,.5,6.317v8.04A1.725,1.725,0,0,0,2.224,16.08h.613v2.948a.574.574,0,0,0,.985.4L7.1,16.08h6.688a1.725,1.725,0,0,0,1.723-1.723V7.843l4.426-4.426a.575.575,0,0,0,0-.812Zm-5.279,9.34L10.6,7.884l4.873-4.873,1.624,1.624ZM9.983,8.9l1.224,1.224-2.1.874Zm4.377,5.461a.575.575,0,0,1-.574.574H6.856a.575.575,0,0,0-.411.173L3.985,17.619V15.505a.574.574,0,0,0-.574-.574H2.224a.575.575,0,0,1-.574-.574V6.317a.575.575,0,0,1,.574-.574h8.888L9.377,7.478a.587.587,0,0,0-.127.192L7.66,11.486h-3.1a.574.574,0,1,0,0,1.148H8.043a.581.581,0,0,0,.226-.046l4.164-1.735a.583.583,0,0,0,.192-.127L14.36,8.991ZM17.9,3.823,16.28,2.2l.812-.812,1.624,1.624Zm0,0",
    transform: "translate(-0.501)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.dbb0c76369f0974961e9d75aed976fb4.svg";
export { ForwardRef as ReactComponent };